exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".base-button[data-v-2a78e53a]{height:32px;border:1px solid #000;border-radius:4px}", ""]);

// exports
